import { render } from "./CookiesCard.vue?vue&type=template&id=08248bcc"
import script from "./CookiesCard.vue?vue&type=script&lang=js"
export * from "./CookiesCard.vue?vue&type=script&lang=js"

import "./CookiesCard.vue?vue&type=style&index=0&id=08248bcc&lang=scss"

import exportComponent from "/home/jeim2750/staging.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__